<template>
  <div class="text-content-wrapper">
    <div class="main-container">
      <div class="content-wrapper">
        <div class="col-wrapper top">
          <slot name="col-1"></slot>
        </div>
      </div>
      <div class="content-wrapper">
        <div class="col-wrapper bottom">
          <slot name="col-2"></slot>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "TextContentWrapper",

}
</script>

<style lang="scss">
@import "TextContentWrapper.scss";
</style>
